import * as z from 'zod';

import { brandQueryLinkerSchema } from '@/_pages/settings/brands/shared';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { aPIKeyQuerySchema } from './api-keys-schemas';
import { connectedAppQueryLinkerSchema } from './connected-app-query-linker-schema';

export const connectedAppQuerySchema = z.object({
  ...connectedAppQueryLinkerSchema.shape,
  brand: brandQueryLinkerSchema.nullable(),
  legal_entity: companyQueryLinkerSchema.nullable(),
  api_keys: z.array(aPIKeyQuerySchema),
});

export type ConnectedAppQuerySchema = z.infer<typeof connectedAppQuerySchema>;

export const connectedAppQueryAllSchema = paginatedResponseSchema(connectedAppQuerySchema);

export type ConnectedAppQueryAllSchema = z.infer<typeof connectedAppQueryAllSchema>;
